@use "../../styles/text";

:host {
  position: relative;
  display: inline-flex;
  .badge-container {
    display: inline-flex;
    .badge-child {
      display: inline-flex;
      hp6-icon-button {
        width: auto;
        height: auto;
      }
    }
    .badge-content {
      @include text.text-heading-xxs;
      font-size: 12px;
      line-height: 22px;
      color: var(--color-text-xlight);
      background-color: var(--color-error-base);
      position: absolute;
      top: 0px;
      right: 0px;
      transform: scale(1) translate(50%, -50%);
      transform-origin: 100% 0%;
      border-radius: 11px;
      white-space: no-wrap;
      cursor: inherit;
      &.show-zero {
        border-radius: 50%;
      }
      &.standard {
        min-height: 15px;
        min-width: 15px;
        padding: 0 3.5px;
        display: inline-block;
        text-align: center;
      }
      &.dot {
        height: 12px;
        width: 12px;
      }
      &.circle {
        top: 14%;
        right: 14%;
        transform-origin: 100% 0%;
      }
      &.border {
        border: 2px solid var(--color-neutral-xxlight);
        border-radius: 13px;
      }
      &.invisible {
        display: none;
      }
    }
  }
}
